import { createAction, props } from '@ngrx/store';

export const callApi = createAction(
  '[API] Call',
  props<{ method: string; endpoint: string; payload?: any; key?: string }>()
);

export const callApiSuccess = createAction(
  '[API] Call Success',
  props<{ key: string; data: any }>()
);

export const callApiFailure = createAction(
  '[API] Call Failure',
  props<{ key: string; error: any }>()
);
